import React, { useState, useEffect, useContext } from "react";
import { Modal, TextField, LegacyCard as Card, Text } from "@shopify/polaris";
import { useMutation } from "@apollo/client";
import { updateOrderNote } from "app/orders/apollo/updateOrderNote";

import baseHelper from "lib/helpers/base";
import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { errorHelper } from "lib/helpers";
import { useParams } from "react-router-dom";

const Notes = (props) => {
  const { cms } = useContext(PrivateContext);
  const { id } = useParams();
  const { dataItem, isEnable, isLiveConnect, note, onRefetchOrderView, setBanner, setMessage } = props;
  const [disabledButton, setDisabledButton] = useState(true);
  const [notes, setNotes] = useState(note);
  const [initialNotes, setInitialNotes] = useState(note);
  const [notesModal, setNotesModal] = useState(false);
  const [updateNewNotes, setUpdateNewNotes] = useState(true);
  const [updateNotes, { loading: loadingNote, error: errorNote, data: dataNote }] = useMutation(updateOrderNote);

  const updateNote = () => {
    const noteValue = initialNotes.trim();
    const formValues = {
      note: initialNotes.trim(),
      // sellerId: dataItem.sellerId,
      // shopifyOrderId: dataItem.shopifyOrderId,
      id,
    };
    updateNotes({ variables: { input: formValues } });
    setUpdateNewNotes(true);
  };
  useEffect(() => {
    if (dataNote && updateNewNotes) {
      const responseNote = baseHelper.getResponseData(dataNote, constant.gql.UPDATE_ORDER_NOTE);
      const responseNoteError = baseHelper.getResponseError(dataNote, constant.gql.UPDATE_ORDER_NOTE);
      if (responseNote) {
        setNotesModal(false);
        setNotes(initialNotes);
        setMessage(cms("message.success.noteUpdated"));
        onRefetchOrderView();
      }
      if (responseNoteError) {
        setNotesModal(false);
        setBanner({
          status: "critical",
          title: responseNoteError,
          isOpen: true,
        });
      }
      setUpdateNewNotes(false);
    }
  }, [dataNote, initialNotes, onRefetchOrderView, setBanner, cms, updateNewNotes]);

  useEffect(() => {
    if (errorNote) {
      setNotesModal(false);
      setBanner({
        status: "critical",
        title: errorHelper.parse(errorNote),
        isOpen: true,
      });
    }
  }, [errorNote, setBanner, cms]);

  const onUpdateNote = (value) => {
    setInitialNotes(value);
    setDisabledButton(!value);
  };

  const renderUpdateNotes = () => {
    return (
      <>
        <Modal
          open={notesModal}
          onClose={() => {
            setNotesModal(false);
            setInitialNotes(notes);
          }}
          title={cms("label.updateNote")}
          primaryAction={{
            content: cms("label.updateNote"),
            onAction: () => updateNote(),
            loading: loadingNote,
          }}
          sectioned
        >
          <Modal.Section>
            <TextField
              label={cms("label.note")}
              maxLength={5000}
              value={initialNotes}
              onChange={(val) => {
                onUpdateNote(val);
              }}
            />
          </Modal.Section>
        </Modal>
      </>
    );
  };

  const updatedNote = (notes && notes.trim()) || cms("label.noNotes");

  return [
    renderUpdateNotes(),
    <Card
      title={cms("label.note")}
      actions={[
        {
          content: cms("label.edit"),
          onAction: () => {
            setNotesModal(true);
            setDisabledButton(true);
          },
        },
      ]}
    >
      <Card.Section>
        <div className="notes">
          <Text as="span" tone={!notes && constant.SUBDUED}>
            {isLiveConnect ? (isEnable && updatedNote) || cms("label.noNotes") : updatedNote}
          </Text>
        </div>
      </Card.Section>
    </Card>,
  ];
};

export default Notes;
